import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { FiEdit2 } from "react-icons/fi";
import { useParams } from "react-router-dom";
import moment from "moment";
import Swal from "sweetalert2";
import jwtDecode from "jwt-decode";
import Loader from "../../../components/loader/loader";
import Snackbar from "../../../components/snackbar/snackbar";
import {
  admin_internship_applications_detail,
  admin_internship_application_qualifications_update,
  admin_internship_application_verify,
  superadmin_internship_applications_detail,
  superadmin_internship_application_verify
} from "../admin.api";
import "./style.css";

const getStatusInfo = (status) => {
  const statusMap = {
    0: {
      label: "Pending",
      class: "pending",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10"></circle>
          <polyline points="12 6 12 12 16 14"></polyline>
        </svg>
      )
    },
    1: {
      label: "Approved",
      class: "successs",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <polyline points="20 6 9 17 4 12"></polyline>
        </svg>
      )
    },
    2: {
      label: "Reverted to User",
      class: "danger",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10"></circle>
          <path d="M12 8v4m0 4h.01"></path>
        </svg>
      )
    },
    3: {
      label: "Rejected",
      class: "danger",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10"></circle>
          <line x1="15" y1="9" x2="9" y2="15"></line>
          <line x1="9" y1="9" x2="15" y2="15"></line>
        </svg>
      )
    },
    4: {
      label: "Submitted for Acceptance",
      class: "info",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10"></circle>
          <polyline points="12 6 12 12 16 14"></polyline>
        </svg>
      )
    },
    5: {
      label: "Reverted to Admin",
      class: "pending",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10"></circle>
          <path d="M12 8v4m0 4h.01"></path>
        </svg>
      )
    },
  };
  const defaultIcon = (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10"></circle>
      <polyline points="12 6 12 12 16 14"></polyline>
    </svg>
  );
  return statusMap[status] || {
    label: "Pending",
    class: "pending",
    icon: defaultIcon
  };
};

const getProposalStatusInfo = (status) => {
  const normalized = status?.toLowerCase();
  switch (normalized) {
    case 'pending':
      return { label: 'Pending', class: 'bg-warning-soft text-warning' };
    case 'approved':
    case 'allotted':
      return { label: 'Assigned to Company', class: 'bg-info-soft text-info' };
    case 'doing':
      return { label: 'Internship in Progress', class: 'bg-primary-soft text-primary' };
    case 'evaluation':
      return { label: 'Evaluation Initiated', class: 'bg-warning-soft text-warning' };
    case 'evaluated':
      return { label: 'Evaluation Completed', class: 'bg-success-soft text-success' };
    case 'certified':
      return { label: 'Certificate Issued', class: 'bg-success-soft text-success' };
    case 'completed':
      return { label: 'Internship Completed', class: 'bg-success-soft text-success' };
    case 'absorbed':
      return { label: 'Absorbed into Company', class: 'bg-success-soft text-success' };
    default:
      return { label: status?.toUpperCase() || '--', class: 'bg-secondary-soft text-secondary' };
  }
};

const getAdminType = (props) => {
  try {
    const token = props?.state?.payload || sessionStorage.getItem("token") || localStorage.getItem("token");
    if (token) {
      const decoded = jwtDecode(token);
      if (decoded && decoded.user_type !== undefined) {
        return Number(decoded.user_type);
      }
    }
  } catch (e) {
    console.error("Error decoding token:", e);
  }
  return Number(localStorage.getItem("adminType")) || 0;
};

export default function InternshipApplicationDetail(props) {
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isUpdating, setIsUpdating] = useState(false);
  const [snackMessage, setSnackMessage] = useState("");
  const [isSnackError, setIsSnackError] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);
  const [showQualificationEditModal, setShowQualificationEditModal] = useState(false);
  const [qualificationForm, setQualificationForm] = useState(null);

  useEffect(() => {
    if (id) {
      fetchDetail();
    }
  }, [id]);

  const fetchDetail = () => {
    setIsLoading(true);
    const adminType = getAdminType(props);
    const apiCall =
      adminType === 2
        ? superadmin_internship_applications_detail(id)
        : admin_internship_applications_detail(id)

    apiCall
      .then((res) => {
        if (res?.success && res?.data) {
          setData(res.data);
        } else {
          setSnackMessage("Failed to load application details");
          setIsSnackError(true);
          setSnackOpen(true);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching detail:", error);
        setSnackMessage("Error loading application details");
        setIsSnackError(true);
        setSnackOpen(true);
        setIsLoading(false);
      });
  };

  const handleVerify = (status) => {
    let title = "";
    let confirmButtonText = "";
    let confirmButtonColor = "";
    let text = "";

    if (status === 1) {
      title = "Approve Application?";
      confirmButtonText = "Yes, Approve";
      confirmButtonColor = "#28a745";
      text = "This will approve the application and make the student eligible for rankings.";
    } else if (status === 2) {
      title = "Revert to User?";
      confirmButtonText = "Yes, Revert";
      confirmButtonColor = "#ffc107";
      text = "Please provide a reason/message for the user.";
    } else if (status === 3) {
      title = "Reject Application?";
      confirmButtonText = "Yes, Reject";
      confirmButtonColor = "#dc3545";
      text = "Please provide a reason/message for the rejection.";
    } else if (status === 4) {
      title = "Submit for Acceptance?";
      confirmButtonText = "Yes, Submit";
      confirmButtonColor = "#007bff";
      text = "This will submit the application to the SuperAdmin for final approval.";
    } else if (status === 5) {
      title = "Revert to Admin?";
      confirmButtonText = "Yes, Revert";
      confirmButtonColor = "#ffc107";
      text = "Please provide a reason/message for the Admin.";
    }

    const needsInput = status === 2 || status === 3 || status === 5;

    Swal.fire({
      title: title,
      text: text,
      input: needsInput ? "textarea" : null,
      inputPlaceholder: "Type your message here...",
      showCancelButton: true,
      confirmButtonText: confirmButtonText,
      confirmButtonColor: confirmButtonColor,
      inputValidator: (value) => {
        if (needsInput && !value) {
          return "You need to write something!";
        }
      },
    }).then((result) => {
      if (result.isConfirmed) {
        setIsUpdating(true);
        const payload = {
          status: status,
          admin_message: needsInput && typeof result.value === "string" ? result.value : "",
        };

        const adminType = getAdminType(props);
        const apiCall = adminType === 2
          ? superadmin_internship_application_verify
          : admin_internship_application_verify;

        apiCall(id, payload)
          .then((res) => {
            if (res?.success) {
              setSnackMessage(res.message || "Status updated successfully");
              setIsSnackError(false);
              setSnackOpen(true);
              props.history.push("/admin-internship-applications");
            } else {
              setSnackMessage(res.message || "Failed to update status");
              setIsSnackError(true);
              setSnackOpen(true);
            }
            setIsUpdating(false);
          })
          .catch((error) => {
            setSnackMessage("Error updating status");
            setIsSnackError(true);
            setSnackOpen(true);
            setIsUpdating(false);
          });
      }
    });
  };

  const snackbarClose = () => {
    setSnackMessage("");
    setIsSnackError(false);
    setSnackOpen(false);
  };

  const openQualificationEditModal = (qualification) => {
    if (!qualification) return;

    setQualificationForm({
      id: qualification.id,
      mark_system: qualification.mark_system || "",
      marks: Array.isArray(qualification.marks)
        ? qualification.marks.map((mark) => ({
          id: mark.id,
          period_label: mark.period_label || "",
          cgpa: mark.cgpa ?? "",
          grade: mark.grade ?? "",
          marks_obtained: mark.marks_obtained ?? "",
          total_marks: mark.total_marks ?? "",
        }))
        : [],
    });
    setShowQualificationEditModal(true);
  };

  const closeQualificationEditModal = () => {
    if (isUpdating) return;
    setShowQualificationEditModal(false);
    setQualificationForm(null);
  };

  const handleQualificationMarkChange = (index, field, value) => {
    setQualificationForm((prev) => ({
      ...prev,
      marks: prev.marks.map((mark, markIndex) =>
        markIndex === index
          ? {
            ...mark,
            [field]: value,
          }
          : mark
      ),
    }));
  };

  const handleQualificationUpdate = () => {
    if (!qualificationForm) return;

    const isGpaSystem =
      qualificationForm.mark_system === "semester_gpa" ||
      qualificationForm.mark_system === "cgpa";

    const payload = {
      qualifications: [
        {
          id: qualificationForm.id,
          mark_system: qualificationForm.mark_system,
          marks: qualificationForm.marks.map((mark) => ({
            id: mark.id,
            ...(isGpaSystem
              ? {
                cgpa:
                  mark.cgpa === "" || mark.cgpa === null
                    ? null
                    : Number(mark.cgpa),
                grade: mark.grade || "",
              }
              : {
                marks_obtained:
                  mark.marks_obtained === "" || mark.marks_obtained === null
                    ? null
                    : Number(mark.marks_obtained),
                total_marks:
                  mark.total_marks === "" || mark.total_marks === null
                    ? null
                    : Number(mark.total_marks),
              }),
          })),
        },
      ],
    };

    setIsUpdating(true);
    admin_internship_application_qualifications_update(id, payload)
      .then((res) => {
        if (res?.success) {
          setSnackMessage(res.message || "Qualification updated successfully");
          setIsSnackError(false);
          setSnackOpen(true);
          setShowQualificationEditModal(false);
          setQualificationForm(null);
          fetchDetail();
        } else {
          setSnackMessage(res?.message || "Failed to update qualification");
          setIsSnackError(true);
          setSnackOpen(true);
        }
      })
      .catch((error) => {
        let errorMessage = "Error updating qualification";
        const resData = error?.response?.data;
        if (resData?.error) {
          if (typeof resData.error === "object") {
            errorMessage = Object.values(resData.error).flat().join(", ");
          } else {
            errorMessage = resData.error;
          }
        } else if (resData?.message) {
          errorMessage = resData.message;
        } else if (error?.message) {
          errorMessage = error.message;
        }

        // Clean up nested validation path strings to be human readable
        errorMessage = errorMessage.replace(/qualifications\.\d+\.marks\.\d+\.cgpa/g, "CGPA");
        errorMessage = errorMessage.replace(/qualifications\.\d+\.marks\.\d+\.marks_obtained/g, "Marks Obtained");
        errorMessage = errorMessage.replace(/qualifications\.\d+\.marks\.\d+\.total_marks/g, "Total Marks");

        setSnackMessage(errorMessage);
        setIsSnackError(true);
        setSnackOpen(true);
      })
      .finally(() => {
        setIsUpdating(false);
      });
  };

  const getBaseUrl = () => {
    return process?.env?.REACT_APP_BASE_URL;
  };

  if (isLoading) return <Loader open={true} />;

  if (!data) return (
    <div className="container mt-5">
      <div className="alert alert-warning">
        <p>Failed to load application details.</p>
        <button className="btn btn-primary btn-sm" onClick={() => props.history.goBack()}>Go Back</button>
      </div>
    </div>
  );

  const statusInfo = getStatusInfo(data.status);

  return (
    <div className="registered-internships-page">
      <Loader open={isUpdating} />
      <Snackbar message={snackMessage} error={isSnackError} open={snackOpen} close={snackbarClose} />

      <div className="container-fluid pt-4 mb-5 px-md-5">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <div className="d-flex align-items-center gap-3">
            <button
              className="btn btn-minimal-outline btn-sm"
              onClick={() => {
                if (props.location.state?.fromRequest) {
                  props.history.push(`/admin-internship-requests/${props.location.state.fromRequest}`);
                } else {
                  props.history.push("/admin-internship-applications");
                }
              }}
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="me-1">
                <line x1="19" y1="12" x2="5" y2="12"></line>
                <polyline points="12 19 5 12 12 5"></polyline>
              </svg>
              {props.location.state?.fromRequest ? "Back" : "Back to List"}
            </button>
            {/* <h4 className="fw-bold text-dark mb-0">Application Entry #{data.id}</h4> */}
          </div>

          {(() => {
            const adminType = getAdminType(props);
            if (adminType === 2) {
              // SuperAdmin actions
              if (data.status === 4) {
                return (
                  <div className="d-flex gap-2">
                    <button
                      className="btn btn-sm btn-success px-4"
                      onClick={() => handleVerify(1)}
                    >
                      Approve
                    </button>
                    <button
                      className="btn btn-sm btn-warning px-4"
                      onClick={() => handleVerify(5)}
                    >
                      Revert to Admin
                    </button>
                    {/* <button
                      className="btn btn-sm btn-danger px-4"
                      onClick={() => handleVerify(3)}
                    >
                      Reject
                    </button> */}
                  </div>
                );
              }
            } else {
              // Regular Admin actions
              if (data.status === 0 || data.status === 5 || data.status === 2) {
                return (
                  <div className="d-flex gap-2">
                    <button
                      className="btn btn-sm btn-primary px-4"
                      onClick={() => handleVerify(4)}
                    >
                      Submit for Acceptance
                    </button>
                    <button
                      className="btn btn-sm btn-warning px-4"
                      onClick={() => handleVerify(2)}
                    >
                      Revert to User
                    </button>
                    {/* <button
                      className="btn btn-sm btn-danger px-4"
                      onClick={() => handleVerify(3)}
                    >
                      Reject
                    </button> */}
                  </div>
                );
              }
            }
            return null;
          })()}
        </div>

        <div className="row g-4">
          {/* Left Column: Summary Sidebar */}
          <div className="col-xl-3 col-lg-4 mb-4">
            <div className="section-card-minimal">
              <div className="section-header">Applicant Overview</div>
              <div className="card-body p-4 text-center">
                <div className="mb-4">
                  {data.file_upload_photo ? (
                    <img
                      src={data.file_upload_photo.startsWith('http') ? data.file_upload_photo : `${getBaseUrl()}${data.file_upload_photo}`}
                      alt="Profile"
                      className="profile-img-minimal"
                    />
                  ) : (
                    <div className="profile-img-minimal bg-light d-inline-flex align-items-center justify-content-center mx-auto">
                      <span className="h1 text-muted mb-0">{data.full_name?.charAt(0)}</span>
                    </div>
                  )}
                </div>
                <h5 className="fw-bold mb-1">{data.full_name}</h5>
                <p className="small text-muted mb-2 opacity-75">Reference ID: {data.reference_id || "--"}</p>
                <p className="small text-muted mb-4 opacity-75">ID: {data.id}</p>

                <div className="text-start">
                  <div className="info-item-minimal mb-3">
                    <label>Application Status</label>
                    <span className={`status-badge ${statusInfo.class} mt-1`}>
                      <span className="status-icon">{statusInfo.icon}</span>
                      <span className="status-label">{statusInfo.label}</span>
                    </span>
                    {data.admin_revert_message && (
                      <div className="alert alert-warning p-2 small mt-2 mb-0" style={{ fontSize: "11px", borderRadius: "6px" }}>
                        <strong>Message/Reason:</strong> {data.admin_revert_message}
                      </div>
                    )}
                  </div>
                  <div className="info-item-minimal mb-3">
                    <label>Email Address</label>
                    <span className="text-break">{data.email}</span>
                  </div>
                  <div className="info-item-minimal mb-3">
                    <label>Contact Number</label>
                    <span>{data.phone_no}</span>
                  </div>
                  <div className="info-item-minimal mb-3">
                    <label>Application Date</label>
                    <span>{moment(data.created_at).format("DD MMM YYYY")}</span>
                  </div>
                </div>

                <div className="mt-4 pt-3 border-top">
                  {data.resume && (
                    <a href={data.resume.startsWith('http') ? data.resume : `${getBaseUrl()}${data.resume}`} target="_blank" rel="noreferrer" className="btn btn-minimal-dark w-100 mb-2">
                      View CV / Resume
                    </a>
                  )}
                  {data.rec_letter_name && (
                    <a href={data.rec_letter_name.startsWith('http') ? data.rec_letter_name : `${getBaseUrl()}${data.rec_letter_name}`} target="_blank" rel="noreferrer" className="btn btn-minimal-dark w-100">
                      View Recommendation Letter
                    </a>
                  )}
                </div>
              </div>
            </div>
            {/* 
            {data.user && (
              <div className="section-card-minimal mt-4 shadow-sm border-0">
                <div className="section-header bg-light">User Account</div>
                <div className="card-body p-3">
                  <div className="info-item-minimal mb-2">
                    <label>Account Name</label>
                    <span>{data.user.name}</span>
                  </div>
                  <div className="info-item-minimal">
                    <label>Linked Mobile</label>
                    <span>{data.user.mobile_number}</span>
                  </div>
                </div>
              </div>
            )} */}

            {data.admin_remarks && (
              <div className="section-card-minimal mt-4 border-warning shadow-sm">
                <div className="section-header bg-warning text-dark border-warning">Internal Feedback</div>
                <div className="card-body p-3">
                  <p className="small mb-0 text-dark">"{data.admin_remarks}"</p>
                </div>
              </div>
            )}
          </div>

          {/* Right Column: Detailed Info */}
          <div className="col-xl-9 col-lg-8">


            <div className="section-card-minimal">

              <div className="section-header">Candidate Profile</div>
              <div className="info-grid-minimal">
                <div className="info-item-minimal">
                  <label>Gender</label>
                  <span>{data.gender || "Not specified"}</span>
                </div>
                <div className="info-item-minimal">
                  <label>Date of Birth</label>
                  <span>{moment(data.date_of_birth).format("DD MMM YYYY")}</span>
                </div>
                <div className="info-item-minimal">
                  <label>Native of Kerala</label>
                  <span>{data.is_kerala_native ? "Yes" : "No"}</span>
                </div>
                <div className="info-item-minimal">
                  <label>Course Track</label>
                  <span className="text-capitalize">{data.course_completion_status}</span>
                </div>
                <div className="info-item-minimal col-span-2">
                  <label>Residential Address</label>
                  <span>{data.address}</span>
                </div>
              </div>
            </div>

            {/* Academic Section with Full Semester/Year Details */}
            <div className="section-card-minimal mt-4">
              <div className="section-header">Evaluation & Academic History</div>
              <div className="card-body p-0">
                {data.intern_qualification?.map((q, idx) => (
                  <div key={idx} className={idx > 0 ? "border-top p-0" : "p-0"}>
                    <div className="bg-light p-3 border-bottom d-flex justify-content-between align-items-center">
                      <div>
                        <span className="badge bg-white text-dark border me-2">{q.qualification_type?.name}</span>
                        <strong className="text-uppercase small">{q.qualification?.name}</strong>
                      </div>
                      <div className="d-flex align-items-center gap-2">
                        {q.certificate_photo && (
                          <a href={q.certificate_photo.startsWith('http') ? q.certificate_photo : `${getBaseUrl()}${q.certificate_photo}`} target="_blank" rel="noreferrer" className="btn btn-minimal-dark btn-sm py-1 font-8">
                            View Certificate
                          </a>
                        )}
                      </div>
                    </div>
                    <div className="p-4">
                      <div className="row mb-4">
                        <div className="col-md-4 mb-3">
                          <label className="text-muted x-small text-uppercase fw-bold mb-1 d-block">Stream / Discipline</label>
                          <div className="d-flex align-items-center gap-2">
                            <span className="fw-bold">{q.stream?.name || "--"}</span>
                          </div>
                        </div>
                        <div className="col-md-4 mb-3">
                          <label className="text-muted x-small text-uppercase fw-bold mb-1 d-block">Board / University</label>
                          <span>{q.board}</span>
                        </div>
                        <div className="col-md-2 mb-3">
                          <label className="text-muted x-small text-uppercase fw-bold mb-1 d-block">Year Passed</label>
                          <span>{q.year_passed}</span>
                        </div>
                        <div className="col-md-2 mb-3">
                          <label className="text-muted x-small text-uppercase fw-bold mb-1 d-block">Scoring Type</label>
                          <span className="text-capitalize">{q.mark_system?.replace('_', ' ')}</span>
                        </div>
                        <div className="col-12 d-flex justify-content-end">
                          {Array.isArray(q.marks) && q.marks.length > 0 && (
                            <button
                              type="button"
                              className="btn btn-outline-primary btn-sm py-1 px-2"
                              onClick={() => openQualificationEditModal(q)}
                              title="Edit marks or CGPA"
                            >
                              <FiEdit2 size={14} />
                            </button>
                          )}
                        </div>

                      </div>
                      {q.marks && q.marks.length > 0 && (
                        <div className="table-responsive rounded-3 overflow-hidden shadow-sm mt-3" style={{ border: '1px solid #333' }}>
                          <table className="table table-sm table-hover mb-0">
                            <thead className="bg-light">
                              <tr style={{ borderBottom: '1px solid #333' }}>
                                <th className="px-3 py-2 border-0 x-small text-muted font-weight-bold" style={{ fontSize: "10px" }}>Academic Period</th>
                                <th className="py-2 border-0 x-small text-muted font-weight-bold" style={{ fontSize: "10px" }}>Result Detail</th>
                                <th className="py-2 border-0 x-small text-muted font-weight-bold text-center" style={{ fontSize: "10px" }}>Score / Performance</th>
                              </tr>
                            </thead>
                            <tbody>
                              {q.marks.map((m, mIdx) => (
                                <tr key={mIdx} className="align-middle">
                                  <td className="px-3 py-2 fw-bold text-secondary small" style={{ borderBottom: mIdx === q.marks.length - 1 ? 'none' : '1px solid #eee' }}>{m.period_label}</td>
                                  <td className="py-2 small text-muted font-weight-bold" style={{ borderBottom: mIdx === q.marks.length - 1 ? 'none' : '1px solid #eee' }}>
                                    {q.mark_system === 'semester_gpa' || q.mark_system === 'cgpa' ? "Semester Point Average" : "Cumulative Marks Distribution"}
                                  </td>
                                  <td className="py-2 text-center" style={{ borderBottom: mIdx === q.marks.length - 1 ? 'none' : '1px solid #eee' }}>
                                    {q.mark_system === 'semester_gpa' || q.mark_system === 'cgpa' ? (
                                      <span className="badge bg-dark-soft text-dark px-3 py-1 font-8 fw-bold">GPA: {m.cgpa || '--'}</span>
                                    ) : (
                                      <div className="d-flex flex-column align-items-center">
                                        <div className="fw-bold small">{m.marks_obtained} / {m.total_marks}</div>
                                        <div className="x-small text-muted font-weight-normal">{m.total_marks ? ((m.marks_obtained / m.total_marks) * 100).toFixed(1) + '%' : ''}</div>
                                      </div>
                                    )}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Internship Proposals Expansion */}
            <div className="section-card-minimal">
              <div className="section-header">Candidate Preferences & Proposals</div>
              <div className="card-body p-0">
                {data.proposals && [...data.proposals].sort((a, b) => a.preference_order - b.preference_order).map((p, idx) => (
                  <div key={idx} className={`p-4 ${idx > 0 ? 'border-top' : ''}`}>
                    <div className="d-flex justify-content-between align-items-start mb-3">
                      <div>
                        <div className="d-flex align-items-center gap-2 mb-1">
                          <span className="badge rounded-circle bg-dark text-white d-inline-flex align-items-center justify-content-center" style={{ width: '24px', height: '24px', fontSize: '10px' }}>0{p.preference_order}</span>
                          <h6 className="fw-bold mb-0 text-primary">{p.internship_request?.internship_discipline}</h6>
                        </div>
                        <p className="text-secondary small mb-2"><i className="bi bi-building me-1"></i> {p.internship_request?.company?.company_name}</p>
                      </div>
                      <div className="text-end">
                        <span className={`badge ${getProposalStatusInfo(p.status).class} py-2 px-3 mb-1`} style={{ borderRadius: '8px' }}>
                          {getProposalStatusInfo(p.status).label}
                        </span>
                        <div className="text-dark-soft x-small fw-bold">Internal Global Rank: {p.admin_rank || "--"}</div>
                      </div>
                    </div>

                    <div className="bg-light rounded-3 p-3 mt-3">
                      <div className="row">
                        <div className="col-md-6 border-end">
                          <div className="mb-2">
                            <label className="x-small text-muted text-uppercase fw-bold d-block mb-1">Brief Description</label>
                            <p className="small text-dark opacity-100 mb-0">{p.internship_request?.brief_description || "No description provided."}</p>
                          </div>
                          <div>
                            <label className="x-small text-muted text-uppercase fw-bold d-block mb-1">Grading Criteria</label>
                            <p className="small mb-0 text-dark-soft">{p.internship_request?.grade_criteria || "None"}</p>
                          </div>
                        </div>
                        <div className="col-md-6 ps-md-4">
                          <div className="row g-2">
                            <div className="col-6">
                              <label className="x-small text-muted text-uppercase fw-bold d-block mb-1">Target Category</label>
                              <div className="d-flex flex-wrap gap-2 mt-1">
                                {p.internship_request?.target_category === 'both' ? (
                                  <>
                                    <span className="badge-target-elite">Students Completed Course</span>
                                    <span className="badge-target-elite">Students Ongoing Course</span>
                                  </>
                                ) : (
                                  <span className="badge-target-elite">
                                    {p.internship_request?.target_category?.replace(/_/g, ' ') || "Both"}
                                  </span>
                                )}
                              </div>
                            </div>
                            <div className="col-6">
                              <label className="x-small text-muted text-uppercase fw-bold d-block mb-1">Students Req.</label>
                              <span className="small fw-bold">{p.internship_request?.number_of_students} Positions</span>
                            </div>
                            <div className="col-12 mt-2 pt-2 border-top">
                              <label className="x-small text-muted text-uppercase fw-bold d-block mb-1">Preferred Duration</label>
                              <span className="small text-muted">
                                {moment(p.internship_request?.preferred_start_date).format("DD MMM YYYY")} - {moment(p.internship_request?.preferred_end_date).format("DD MMM YYYY")}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

          </div>
        </div>
      </div>

      <Modal
        show={showQualificationEditModal}
        onHide={closeQualificationEditModal}
        centered
        size="lg"
        backdrop="static"
      >
        {/* <Modal.Header closeButton={!isUpdating}> */}
        <Modal.Title>Edit Qualification Details</Modal.Title>
        {/* </Modal.Header> */}
        <Modal.Body>
          {qualificationForm && (
            <>
              <div className="mb-3">
                <label className="form-label small text-uppercase fw-bold">Mark System</label>
                <input
                  type="text"
                  className="form-control"
                  value={qualificationForm.mark_system?.replace(/_/g, " ")}
                  disabled
                />
              </div>

              <div className="table-responsive">
                <table className="table table-bordered align-middle mb-0">
                  <thead className="table-light">
                    <tr>
                      <th>Academic Period</th>
                      {qualificationForm.mark_system === "semester_gpa" ||
                        qualificationForm.mark_system === "cgpa" ? (
                        <>
                          <th>CGPA</th>
                        </>
                      ) : (
                        <>
                          <th>Marks Obtained</th>
                          <th>Total Marks</th>
                        </>
                      )}
                    </tr>
                  </thead>
                  <tbody>
                    {qualificationForm.marks.map((mark, index) => (
                      <tr key={mark.id || index}>
                        <td>{mark.period_label || `Row ${index + 1}`}</td>
                        {qualificationForm.mark_system === "semester_gpa" ||
                          qualificationForm.mark_system === "cgpa" ? (
                          <>
                            <td>
                              <input
                                type="number"
                                className="form-control"
                                step="0.01"
                                value={mark.cgpa}
                                onChange={(e) =>
                                  handleQualificationMarkChange(index, "cgpa", e.target.value)
                                }
                              />
                            </td>
                          </>
                        ) : (
                          <>
                            <td>
                              <input
                                type="number"
                                className="form-control"
                                step="0.01"
                                value={mark.marks_obtained}
                                onChange={(e) =>
                                  handleQualificationMarkChange(
                                    index,
                                    "marks_obtained",
                                    e.target.value
                                  )
                                }
                              />
                            </td>
                            <td>
                              <input
                                type="number"
                                className="form-control"
                                step="0.01"
                                value={mark.total_marks}
                                disabled
                              />
                            </td>
                          </>
                        )}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-secondary"
            onClick={closeQualificationEditModal}
            disabled={isUpdating}
          >
            Cancel
          </button>
          <button
            type="button"
            className="btn btn-secondary px-4"
            onClick={handleQualificationUpdate}
            disabled={!qualificationForm || isUpdating}
          >
            Save
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
